import React from 'react';
import { DBO_V } from '@op/utils/format';
import PercentageItem from '@op/components/Snippets/PercentageItem';
import RingRatioBubble from '@op/components/Snippets/RingRatioBubble';
import { parseLinkTime } from '@opm/components/KPICell';
import { IKPIValue } from '../../types';

interface ITrendInfoKpiRowProps {
  /** 行标签（如 'Impressions'） */
  label: string;
  /** KPI 数据（含 value / old_value / link_time） */
  kpiData: IKPIValue;
  /** 数值格式化函数，默认 DBO_V.reviews（不保留小数） */
  formatValue?: (v: number) => string | number;
}

/**
 * Drawer TrendInfo 区 KPI 行（label + 数值 + DoD 环比）
 *
 * 消除 Impressions / Creatives / Avg.Days Active 三行的重复 JSX 结构
 */
export default function TrendInfoKpiRow({
  label,
  kpiData,
  formatValue = DBO_V.reviews,
}: ITrendInfoKpiRowProps) {
  const { oldTime, newTime } = parseLinkTime(kpiData?.link_time);
  const value = kpiData?.value || 0;
  const oldValue = kpiData?.old_value || 0;
  // 统一用 DBO_V.qoq（= getRationPercentValue），内部已兜底 0 / Infinity / 负值
  const ratio = DBO_V.qoq(value, oldValue);
  return (
    <div className="dbom-ct-drawer-info__row">
      <div className="dbom-ct-drawer-info__label">{label}</div>
      <div className="dbom-ct-drawer-info__value">
        <span className="dbom-ct-drawer-info__value-text">
          {formatValue(value || 0)}
        </span>
        <RingRatioBubble
          oldTime={oldTime}
          newTime={newTime}
          oldValue={oldValue}
          newValue={value}
          formateValue={formatValue}
        >
          <PercentageItem percentage={ratio} />
        </RingRatioBubble>
      </div>
    </div>
  );
}
